<header id="header">
  <div class="layout-center-wrapper">
    <div class="row noMargin container_header">
      <div class="col-md-11">
      <div class="header__logo">
        <img style="width: 80px;margin-right: 10px;" src="assets/images/DeloitteLogo.png" />
        <span>|</span>&nbsp;&nbsp;PNS</div>
      </div>
     <div class="col-md-1">
      <div class="clsProfileDiv" (click)="showUserPopup()">
        <img width="30px" height="30px" graphImageUrl="{{userImage}}" style="margin-right:4px;"  #userImg/>
        <div  class="centered clsUserAvatar" *ngIf="userImg.style.display=='none'" [userName]="displayUserName"></div>
        <img style="right:5px;width:12px" src="assets/images/profile-arrow-up-icon.png" />
      </div>
    </div>
    </div>
  </div>
</header>
<div *ngIf="showUserProfileDiv" class="profileViewContainer" clickElsewhere (clickOff)="closeDropdown($event)">
  <div class="row noMargin clsPadding">
    <div class="col-md-3" style="height:40px;width: 50px">
      <img height="40px" width="40px" graphImageUrl="{{userImage}}"  #userImgDiv/>
      <div  class="clsUserProfileAvatar" *ngIf="userImgDiv.style.display=='none'" [userName]="displayUserName"></div>
      &nbsp;
    </div>
    <div class="col-md-9">
      <p style="margin-bottom:3px">{{username}}
      <p>{{userEmail}}</p>
    </div>
  </div>
  <div class="row margin_15 clsPadding paddingLeft_9" >
    <span (click)="redirectToProfile()" style="cursor: pointer !important"><img  style="width: 25px;" src="assets/images/profile-icon.png"><span class="clsPaddingLeft">Profile</span></span>
  </div>
  <div class="row margin_15 clsPadding paddingLeft_9">
    <span (click)="signout()" style="cursor: pointer !important"><img style="width: 25px;" src="assets/images/sign-out-icon.png"><span class="clsPaddingLeft">Sign out</span></span>
  </div>
</div>

<app-signout [isSessionExpired]="isSessionExpired" (onModalClose)="close($event)" [hidden]="!showModal">

</app-signout>
